<div class="container">
  <categories-bizagi-data
    [filteredCategoryListBizagiData]="filteredCategoryListBizagiData"
    [selectedItem]="selectedItem"
    (itemSelected)="onItemSelected($event)"
    (itemRefresh)="refreshBizagiData($event)"></categories-bizagi-data>

  <bizagi-data-detail
    [selectedItem]="selectedItem"
    [kbLearnedDetails]="kBLearnedWithDetails?.LearnedEntityDetails"
    [isLoadingDetails]="isLoadingDetails"
    (refreshItem)="refreshBizagiData(selectedItem)"></bizagi-data-detail>
</div>